import { Helmet } from 'react-helmet-async';
import PageTitleWrapper from 'src/components/PageTitleWrapper';
import { Grid, Container, Typography, Box, LinearProgress } from '@mui/material';
import Footer from 'src/components/Footer';
import PageHeader from './PageHeader';
import LeaderboardIcon from '@mui/icons-material/Leaderboard';
import OrderSalesSummary from '../reports/daily-sales-report/OrderSalesSummary';
import { OrdersReportDailySummary } from 'src/services/apiService/response-models/report';
import dayjs from 'dayjs';
import { useEffect, useState } from 'react';
import { getDailySalesSummaryReport } from 'src/services/apiService/reports';


function HomePage() {
  const [dailySalesSummary, setDailySalesSummary] = useState<OrdersReportDailySummary | null>(null);
const [fromDate, setFromDate] = useState(
    dayjs().subtract(7, 'day').format('MM-DD-YYYY')
  );
  const [toDate, setToDate] = useState(dayjs().format('MM-DD-YYYY'));
  const [loading, setIsLoading] = useState(true);
  const [error, setError] = useState('');

  const getItems = async (
      from = fromDate,
      to = toDate,
      appRegisterId = '',
      employeeId = ''
    ) => {
      try {
        setError('');
        const response = await getDailySalesSummaryReport(
          from,
          to,
          appRegisterId || undefined,
          employeeId || undefined
        );
        setDailySalesSummary(response.data);
        setIsLoading(false);
      } catch (err: any) {
        setDailySalesSummary(null);
        setError(
          err?.response?.data?.message || err?.message || 'Failed to load items'
        );
        setIsLoading(false);
      }
    };
    // Call the function to fetch items
    useEffect(() => {
      setIsLoading(true);
      getItems();
    }, []);
  return (
    <>
      <Helmet>
        <title>Home</title>
      </Helmet>
      <PageTitleWrapper>
        <PageHeader />
      </PageTitleWrapper>
      <Container maxWidth="lg">
        <Grid
          container
          direction="row"
          justifyContent="center"
          alignItems="stretch"
          spacing={3}
        >
          <Grid item xs={12}>
            <Box
              sx={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'space-between',
                mb: 3
              }}
            >
              <Typography variant="h3" component="h1" gutterBottom>
                <LeaderboardIcon sx={{ mr: 1 }} />
                Weekly Sales Summary ({fromDate} - {toDate})
              </Typography>
            </Box>
            
           </Grid>
          <Grid item xs={12}>
            {loading && (
             <LinearProgress sx={{ my: 2 }} />
            ) }
            <OrderSalesSummary summary={dailySalesSummary} />
          </Grid>
        </Grid>
      </Container>
      <Footer />
    </>
  );
}

export default HomePage;
